import type { Permission } from '@ztechapps/common.contract'

/**
 * Permissions for the shared AI usage-metering + credit-billing engine. App-agnostic by
 * design: a single generic `canManageAiBilling` gates the admin ops (grant credits, edit
 * model/currency/FX rates) across EVERY consuming app (QuickScore, TotalMilk, …), so the
 * engine never needs a per-app permission name in config.
 */
export const aiPermissions = {
  canManageAiBilling: {
    value: 'canManageAiBilling',
    label: 'Can Manage AI Billing',
    description: 'Allows the user to manage AI usage billing — grant credits and edit model/currency/FX rates.',
  } satisfies Permission,

  canAccessMcp: {
    value: 'canAccessMcp',
    label: 'Can Access MCP',
    description: 'Allows the user to authenticate to the external MCP endpoint (/mcp) with an api-scoped login token.',
  } satisfies Permission,
}
